// Taşeron portalı — sürükle-bırak kaplaması (plan S19-D7, tasarım review §4/§12).
//
// Çağıranın `relative` KABI İÇİNDE `absolute inset-0` konumlanır — ASLA `fixed`: bir viewport
// kaplaması başlığı, navı VE panel/tepsiyi (`--z-dropdown`) örterdi ve bunun için bir katman
// token'ı da YOKTUR (`--z-drawer`/`--z-toast` bu dilimde BOŞ kalmalıdır). `--z-base` (0),
// `pointer-events-none` — TIKLANAMAZ, yalnız geri bildirimdir; yükleme afordansı HER ZAMAN
// `Belge Yükle` düğmesidir (klavye yolu). Görünürlüğü çağıran bir SÜRÜKLEME SAYACIYLA sürer
// (boolean DEĞİL) — `dragleave` her çocuk elemana geçişte ateşlenir, sayaç olmadan kaplama
// TİTRER (bkz. çağıranın `dragCounterRef`'i).

import { UploadCloud } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function DropOverlay({ active }: { active: boolean }) {
  const { t } = useTranslation();
  if (!active) {
    return null;
  }
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 z-[var(--z-base)] flex flex-col items-center justify-center gap-2 border-2 border-dashed border-primary bg-bg/80"
    >
      <UploadCloud className="h-8 w-8 text-primary" aria-hidden="true" />
      <p className="text-sm font-medium text-fg">{t('documents.dropHere')}</p>
      <p className="text-xs text-muted">{t('documents.dropHint')}</p>
    </div>
  );
}
